import React, { useEffect } from 'react';
import { Button } from '@asigna/kit';
import { NoData } from 'components';
import { SendStxsDialog } from 'components/Dialog/TransactionDialog/SendStxsDialog';
import { SkeletonStx20 } from 'components/Skeletons/SkeletonAsset';
import {
  TransactionNotification,
  TransactionResultStatus,
} from 'components/TransactionNotification/TransactionNotification';
import useNetwork from 'hooks/use-network';
import { uniqueId } from 'lodash';
import BlankIcon from 'modules/icons/icon-blank.svg';

import { getStxMapByAddress } from '../../../utils';
import { Pagination } from '../../Pagination';

import { useStxmapTab } from './util/useStxmapTab';
import { useStxmapStyles } from './StxmapStyles';

type Props = {
  currentSafe: string;
};

export const StxmapTab = ({ currentSafe }: Props) => {
  const classes = useStxmapStyles();
  const LIMIT = 8;
  const [network] = useNetwork();
  const {
    isLoading,
    setLoading,
    searchStxMapResult,
    setSearchStxMapResult,
    currentPage,
    setCurrentPage,
    pagination,
    setPagination,
    transferredAsset,
    setTransferredAsset,
    instantSendDialogShown,
    setInstantSendDialogShown,
    transactionMessagePopupShown,
    setTransactionMessagePopupShown,
    transactionResultStatus,
    setTransactionResultStatus,
    transactionResultMessage,
    setTransactionResultMessage,
  } = useStxmapTab();

  const fetchStxMap = async (address: string) => {
    setLoading(true);
    setSearchStxMapResult(undefined);
    try {
      const result = await getStxMapByAddress(address, currentPage, LIMIT, network);
      setSearchStxMapResult(result.data);
      setPagination(result.pagination);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStxMap(currentSafe);
  }, [currentSafe, currentPage]);

  return (
    <div className={classes.stxmapWrapper}>
      {searchStxMapResult && searchStxMapResult?.length > 0 && (
        <div className={classes.stxmapHeader}>
          <span>Block Number</span>
          {/* <span>Registered At</span>
          <span>Owner</span> */}
          <span></span>
        </div>
      )}
      {isLoading ? (
        <SkeletonStx20 />
      ) : (
        <div className={classes.contentWrapper}>
          {searchStxMapResult && searchStxMapResult?.length > 0 ? (
            searchStxMapResult?.map((stxMap) => (
              <div className={classes.tableRow} key={uniqueId(stxMap.stxmap)}>
                <div className={classes.blockNumber}>
                  <div className={classes.rowTableIcon}>
                    <img src={BlankIcon} alt="" />
                  </div>
                  <div className={classes.caption}>
                    {stxMap.stxmap.split('.')[0]}
                    <span>.stxmap</span>
                  </div>
                </div>
                {/* <div className={classes.itemRow}>
                  <div className={classes.title}>{formatSafeDate(stxMap.creationDate)}</div>
                </div>
                <div className={classes.ownerRow}>
                  <div className={classes.title}>{shortenAddress(stxMap.owner)}</div>
                  <CopyAddress address={stxMap.owner} />
                  <div
                    className={classes.sendBlock}
                    onClick={() => window.open(getAccountExplorerUrl(stxMap.owner, network))}
                  >
                    <img src={LinkIcon} alt="" />
                  </div>
                </div> */}
                <div className={classes.itemActions}>
                  <Button
                    colorType="secondary"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTransferredAsset(`${stxMap.stxmap.split('.')[0]}.stxmap`);
                      setInstantSendDialogShown(true);
                    }}
                    message="Send"
                  />
                </div>
              </div>
            ))
          ) : (
            <div className={classes.noDataWrapper}>
              <NoData isAssets style={{ margin: '32px 0 16px' }} />
              <Button
                onClick={() => window.open('https://stx20.com/marketplace', `_blank`)}
                message="Go to STX20 Marketplace"
                colorType="secondary"
                size="md"
              />
            </div>
          )}
          <Pagination
            currentPage={pagination?.page || 0}
            pageCount={Math.ceil(Number(pagination?.count || 1) / LIMIT)}
            onChange={(val) => {
              setCurrentPage(val);
            }}
          />
        </div>
      )}
      {instantSendDialogShown && (
        <SendStxsDialog
          open={instantSendDialogShown}
          transferredAsset={transferredAsset}
          safeAddress={currentSafe}
          onClose={() => setInstantSendDialogShown(false)}
          onContinue={(successful, message) => {
            setTransactionMessagePopupShown(true);
            setTransactionResultStatus(
              successful ? TransactionResultStatus.success : TransactionResultStatus.rejected
            );
            setTransactionResultMessage(message);
          }}
        />
      )}
      {transactionMessagePopupShown && (
        <TransactionNotification
          open={transactionMessagePopupShown}
          onClose={() => setTransactionMessagePopupShown(false)}
          resultStatus={transactionResultStatus}
          description={transactionResultMessage}
        />
      )}
    </div>
  );
};
